<template>
  <div
    class="toastification pointer"
    @click.prevent="onClick()">
    <div class="d-flex justify-end">
      <span
        class="cursor-pointer toastification-close-icon ml-auto "
        @click="$emit('close-toast')"
      >
        <feather-icon
          v-if="!hideClose"
          icon="XIcon"
          class="text-body"
        />
      </span>
    </div>
    <div class="d-flex align-items-start">
      <b-avatar
        :variant="variant"
        size="1.8rem"
        class="mr-75 flex-shrink-0"
      >
        <feather-icon
          :icon="icon"
          size="15"
        />
      </b-avatar>
      <div class="d-flex flex-column flex-grow-1">
        <div
          v-if="customerGroup"
          class="d-flex align-items-center"
        >
          <feather-icon
            v-if="notificationColor"
            icon="BellIcon"
            :class="{ 'bell-shake': notificationColor }"
            class="mr-50"
            size="20"
            :style="{ color: notificationColor }"
          />
          <div 
            class="font-weight-bolder customer-group-badge"
            :style="customerGroupStyle"
            v-text="customerGroup" 
          />
        </div>
        <div
          v-if="customerName"
          class="mt-1">
          <div
            class="d-inline-block text-body"
            v-text="`Customer Name: ${customerName}`"
          >
          </div>
        </div>
        <div
          v-if="contactName"
          class="mt-1">
          <div
            class="d-inline-block text-body"
            v-text="`Contact Name: ${contactName}`"
          >
          </div>
        </div>
        <div>
          <h5
            v-if="title"
            class="mb-0 font-weight-bolder toastification-title"
            :class="`text-${variant}`"
            v-text="title"
          />
          <small
            v-if="text"
            class="d-inline-block text-body"
            v-text="text"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BAvatar } from 'bootstrap-vue'

export default {
  components: {
    BAvatar
  },
  props: {
    variant: {
      type: String,
      default: 'primary'
    },
    icon: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    hideClose: {
      type: Boolean,
      default: false
    },
    timeout: {
      type: Number,
      default: 3600000
    },
    customerName: {
      type: String,
      default: null
    },
    contactName: {
      type: String,
      default: null
    },
    isHaveContact: {
      type: Boolean,
      default: false
    },
    customerGroup: {
      type: String,
      default: null
    },
    notificationColor: {
      type: String,
      default: null
    }
  },
  computed: {
    customerGroupStyle() {
      if (!this.notificationColor) {
        return {}
      }
      const textColor = this.getContrastColor(this.notificationColor)
      return {
        '--badge-bg-color': this.notificationColor,
        '--badge-text-color': textColor,
        backgroundColor: this.notificationColor,
        color: textColor,
        padding: '4px 8px',
        borderRadius: '4px'
      }
    }
  },
  methods: {
    onClick () {
      this.$emit('click')
    },
    getContrastColor(hexColor) {
      // Convert hex to RGB
      const hex = hexColor.replace('#', '')
      const r = parseInt(hex.substr(0, 2), 16)
      const g = parseInt(hex.substr(2, 2), 16)
      const b = parseInt(hex.substr(4, 2), 16)
      
      // Calculate luminance
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
      
      // Return black for light backgrounds, white for dark backgrounds
      return luminance > 0.5 ? '#000000' : '#FFFFFF'
    }
  }
}
</script>

<style lang="scss" scoped>
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}

.toastification-title {
  color: inherit;
}

.pointer {
  cursor: pointer;
}

.customer-group-badge {
  font-size: 1.1rem;
  color: var(--badge-text-color) !important;
}

.bell-shake {
  animation: bellShake 0.5s ease-in-out infinite;
  transform-origin: top center;
}

@keyframes bellShake {
  0%, 100% {
    transform: rotate(0deg);
  }
  10%, 30% {
    transform: rotate(-10deg);
  }
  20%, 40% {
    transform: rotate(10deg);
  }
  50% {
    transform: rotate(0deg);
  }
}
</style>
